import { connect } from 'react-redux';
import { useEffect } from 'react';
import './MainLayout.scss';
import { AppSidebar, AppFooter, AppHeader } from '../../components/index'
function MainLayout({ ...props }) {
  const { children } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <div>
      <AppSidebar />
      <div className="wrapper d-flex flex-column min-vh-100">
        <AppHeader />
        <div className="body flex-grow-1">
        {children}
        </div>
        <AppFooter />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    MainLayoutStatus: 'True',
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MainLayout);